<template>
    <div class="box-content px-[8px] relative overflow-hidden">
            <h3 class="absolute text-sm md:text-lg top-2 left-4 md:top-10 md:left-10 font-semibold uppercase text-teal-500 font-sans">about us</h3>
            <div class="flex gap-[8px] md:gap-3 w-fit mx-auto flex-row mt-4 md:mt-0 justify-center overflow-hidden bg-white relative z-10 px-2">
                <h3 data-aos="fade-left" data-aos-duration="1000" class="mb-0 text-6xl lg:text-8xl text-prime-color text-center"><i>About</i></h3>
                <h3 data-aos="fade-right" data-aos-duration="1000" class="text-6xl lg:text-8xl text-prime-color text-center"><i>HUET</i></h3>
            </div>
            <p data-aos="fade-in" data-aos-duration="2000" class="pt-[12px] md:pt-5 pb-3 md:pr-4 font-medium uppercase text-center text-base md:text-xl text-prime-color font-sans">Giới thiệu về HUET</p>
            <div class="d-md-flex flex-row gap-4 px-[8px] justify-center">
                <div class="d-md-flex justify-content-center justify-content-lg-start">
                    <iframe class="w-full h-[240px] sm:h-[300px] md:h-full md:w-[300px] lg:w-[400px] rounded-md" src="https://www.youtube.com/embed/JTKbKTRTRKU" allowfullscreen></iframe>
                </div>
                <div class="about mt-[12px] md:mt-0">
                    <p class="mb-0 w-full lg:max-w-[600px] relative z-10">
                        "{{ aboutData }}"
                    </p>
                    <div class="d-flex justify-content-end transition-all duration-300 gap-2 hover:gap-0 mt-2" style="cursor: pointer;" @click="redirect('about')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z"></path></svg>
                        <h5 class="mb-0">Tìm hiểu ngay</h5>
                    </div>
                </div>
            </div>
            <img class="absolute top-0 right-16 w-0 xl:w-40 xl:h-96 object-cover z-0" src="@/assets/img/admission/admission-banner-2.png" alt="">
    </div>
</template>

<script>
export default {
    props: {
        aboutData: String
    },
    methods: {
        redirect(page) {
            this.$router.push({name: 'user.' + page})
        }
    },
}
</script>


<style lang="scss" scoped>
.home-title {
    color: var(--orange400);
    width: fit-content;
    font-weight: 600;
}
.about {
    h4 {
        font-size: 22px;
        text-align: center;
        color: var(--orange500);
    }
    p {
        text-align: justify;
        font-size: 20px;
        text-shadow: 2px 2px 4px white;
    }
}
@media screen and (min-width: 768px) {
    
}

@media screen and (min-width: 992px) {
    
}
</style>